import { render, staticRenderFns } from "./Alphabet.vue?vue&type=template&id=63945998&scoped=true&"
import script from "./Alphabet.vue?vue&type=script&lang=js&"
export * from "./Alphabet.vue?vue&type=script&lang=js&"
import style0 from "./Alphabet.vue?vue&type=style&index=0&id=63945998&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63945998",
  null
  
)

export default component.exports